import { PartialDoctorSignature } from "../../partials/doctorSignature";
import { PartialResponsibleSignature } from "../../partials/responsibleSignature";

export const termDischargeRisksResponsibility = {
  name: "Termo de Responsabilidade para Retirada sem Alta Médica",
  title:
    "Termo de Responsabilidade e Esclarecimento para Retirada do \nEstabelecimento Veterinário sem Alta Médica",
  gender: "male",
  fields: {
    microchip: {
      label: "Nº Microchip",
      type: "text",
      required: false,
    },
    identifications: {
      label: "Outras informações de identificação",
      type: "textarea",
      required: false,
      props: {
        rows: 2,
        style: { minWidth: "100%" },
      },
    },
    risks: {
      label: "Riscos da retirada",
      type: "textarea",
      required: true,
      defaultPreview: _.range(50).fill("_").join(""),
      props: {
        rows: 4,
        style: { minWidth: "100%" },
      },
    },
  },
  partials: {
    doctorSignature: {
      defaultValue: true,
      partial: PartialDoctorSignature,
    },
    responsibleSignature: {
      defaultValue: true,
      partial: PartialResponsibleSignature,
    },
  },
  content: `
   <p>Declaro que o animal identificado neste documento{{#microchip}}, nº do microchip: <span>{{microchip}}</span>{{/microchip}}{{#identifications}}, {{{identifications}}}{{/identifications}}, não obteve alta médica para deixar o estabelecimento veterinário.</p>
   <p>Informo que foram prestados todos os esclarecimentos sobre diagnóstico, condições clínicas, possibilidades terapêuticas e consequências relacionadas à minha recusa de atendimento e/ou tratamento propostos ao meu animal.</p>
   <p>Afirmo conhecer sobre os possíveis danos advindos da minha opção pela interrupção da assistência médica-veterinária em meu animal, principalmente diante da gravidade da enfermidade e de seu prognóstico, tais como riscos de agravamento do quadro, como por exemplo:</p>
   <p><span>{{{risks}}}</span>.</p>
   <p>Declaro, ainda, que a Clínica (Hospital) Veterinária se colocou inteiramente à disposição para prestar todo e quaisquer esclarecimentos futuros a respeito do tratamento prestado ao animal, tanto para mim como para outro profissional médico veterinário de minha escolha.</p>
   <p>Tenho ciência de que o médico veterinário, nos casos de Retirada sem Alta, fica desobrigado à prescrição de tratamento paliativo e que qualquer tratamento alternativo solicitado por mim e prescrito pelo médico assistente visa apenas garantir o mínimo de bem-estar e saúde do animal, mas o mantém em risco, estando isentos, portanto, médico veterinário e estabelecimento, da responsabilidade por quaisquer consequências adversas à saúde do paciente.</p>
   <p>Por fim, diante de todos os esclarecimentos e informações prestados, sem qualquer prejuízo da reconsideração de minha decisão e retorno a este estabelecimento, opto, por razões de ordens pessoais, pela retirada sem alta médica-veterinária do animal de minha responsabilidade.</p>

    {{#responsibleSignature}}
      <br />
      <br />
      <br />
      <br />
      <br />
      {{>responsibleSignature}}
    {{/responsibleSignature}}
    {{#doctorSignature}}
      <br />
      <br />
      <br />
      {{>doctorSignature}}
    {{/doctorSignature}}
  `.trim(),
};
